module.exports = __webpack_public_path__ + "static/media/call-flows.2dfdd624.png";